import { cn } from "#lib/utils"
import { AlertCircle, CheckCircle2, Info, Lightbulb } from "lucide-react"
import * as React from "react"

export interface CalloutProps extends React.ComponentProps<"div"> {
  variant?: "tip" | "info" | "warning" | "success"
  icon?: React.ReactNode
}

const variantStyles = {
  tip: {
    container: "border-primary/50 bg-primary/5",
    icon: "text-primary",
  },
  info: {
    container: "border-blue-500/50 bg-blue-500/5",
    icon: "text-blue-500",
  },
  warning: {
    container: "border-amber-500/50 bg-amber-500/5",
    icon: "text-amber-500",
  },
  success: {
    container: "border-green-500/50 bg-green-500/5",
    icon: "text-green-500",
  },
}

const defaultIcons = {
  tip: Lightbulb,
  info: Info,
  warning: AlertCircle,
  success: CheckCircle2,
}

export function Callout({ variant = "info", icon, className, children, ...props }: CalloutProps) {
  const Icon = icon || defaultIcons[variant]
  const styles = variantStyles[variant]

  return (
    <div className={cn("rounded-lg border p-4 flex gap-3", styles.container, className)} {...props}>
      {typeof Icon === "function" ? (
        <Icon className={cn("w-5 h-5 flex-shrink-0 mt-0.5", styles.icon)} />
      ) : (
        <div className={cn("flex-shrink-0 mt-0.5", styles.icon)}>{icon}</div>
      )}
      <div className="flex-1 text-sm [&>p]:m-0 [&>p:not(:last-child)]:mb-2">{children}</div>
    </div>
  )
}
